import { render, staticRenderFns } from "./CampanhaAccordion.vue?vue&type=template&id=b5340b8c&scoped=true"
import script from "./CampanhaAccordion.vue?vue&type=script&lang=js"
export * from "./CampanhaAccordion.vue?vue&type=script&lang=js"
import style0 from "./CampanhaAccordion.vue?vue&type=style&index=0&id=b5340b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5340b8c",
  null
  
)

export default component.exports